import { FC, useEffect, useState } from "react";
import { SettingsSubsectionWrapper } from "@/pages/settings/components/setting-subsection-wrapper";
import { SettingsSectionWrapper } from "@/pages/settings/components/settings-section-wrapper";
import { DeleteAccountModal } from "@/pages/settings/components/delete-account-modal";
import { observer } from "mobx-react-lite";
import {
  MDSText,
  MDSTextVariant,
  MDSButton,
  MDSButtonSlotName,
  MDSButtonVariant,
  MDSIcon,
  MDSIconKind,
} from "@/mds";
import styled from "@emotion/styled";
import { useAppStore } from "@/store";
import { LoadingSubscriptions } from "@/pages/settings/components/subscription-management/loading-subscriptions";

export const SettingsAccountManagementPage: FC = observer(() => {
  const { store, pageStore } = useAppStore();
  const [isDeleteAccountModalOpen, setIsDeleteAccountModalOpen] = useState(false);

  const accountManagementPageStore = pageStore.settingsAccountManagementPage;
  const hasActiveSubscription = accountManagementPageStore.hasRenewingSubscription;
  const isLoading = accountManagementPageStore.isLoading;

  useEffect(() => {
    accountManagementPageStore.refresh();
  }, [accountManagementPageStore]);

  return (
    <>
      <DeleteAccountModal
        isOpen={isDeleteAccountModalOpen}
        handleClose={() => setIsDeleteAccountModalOpen(false)}
      />
      <SettingsSectionWrapper>
        <SettingsSubsectionWrapper title="Account management">
          {isLoading ? (
            <LoadingSubscriptions />
          ) : (
            <StyledContentWrapper>
              {hasActiveSubscription ? (
                <>
                  <MDSText variant={MDSTextVariant.ParagraphS}>
                    You have an active Mem subscription.
                  </MDSText>
                  <MDSText variant={MDSTextVariant.ParagraphS}>
                    Please manage your subscription before deleting your account.
                  </MDSText>
                  <MDSButton onClick={() => store.navigation.goToSettingsSubscriptionManagement()}>
                    Manage subscription
                  </MDSButton>
                </>
              ) : (
                <>
                  <MDSText variant={MDSTextVariant.ParagraphS}>
                    By clicking the button below you will be asked to confirm that you want to
                    delete your account. <Strong>This action is irreversible.</Strong>
                  </MDSText>
                  <MDSButton
                    onClick={() => setIsDeleteAccountModalOpen(true)}
                    variant={MDSButtonVariant.DangerFilled}
                  >
                    <MDSIcon kind={MDSIconKind.Warning} slot={MDSButtonSlotName.LeftIcon} />
                    Continue with account deletion
                  </MDSButton>
                </>
              )}
            </StyledContentWrapper>
          )}
        </SettingsSubsectionWrapper>
      </SettingsSectionWrapper>
    </>
  );
});

const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${({ theme }) => theme.spacing[2]} 0;
  gap: ${({ theme }) => theme.spacing[5]};
`;

const Strong = styled.strong`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;
